<template>
  <v-app>
    <nav>
      <router-link to="/" exact active-class="active-link" class="nav-link">
        Consultar lista
      </router-link>
      ·
      <router-link
        to="/newlist"
        exact
        active-class="active-link"
        class="nav-link"
      >
        Nueva lista
      </router-link>
      ·
      <router-link to="/faqs" exact active-class="active-link" class="nav-link">
        FAQs
      </router-link>
      <ThemeToggle />
    </nav>
    <router-view />
  </v-app>
</template>

<script>
import ThemeToggle from "./components/ThemeToggle.vue";
import { useTheme } from "vuetify";
export default {
  components: {
    ThemeToggle,
  },
  setup() {
    const theme = useTheme();

    return {
      theme,
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  text-decoration: none;
}

.iconTheme {
  float: right;
}

/* Estilos para los enlaces */
.nav-link {
  color: inherit; /* Usar el color por defecto de texto */
  text-decoration: none; /* Sin subrayado */
  margin: 0 5px; /* Espaciado entre enlaces */
  transition: color 0.3s; /* Transición suave del color */
}

/* Estilo para enlaces activos */
.active-link {
  color: rgb(var(--v-theme-primary)); /* Cambiar el color para enlaces activos */
  font-weight: bold; /* Resaltar enlaces activos */
}

/* Estilo para identificar la página actual */
.v-app.nav-on-home-page {
  background-color: #f0f0f0; /* Cambiar el fondo para indicar la página actual */
}
</style>
